import { module } from 'modujs';
import { randomSeed as randomSeedInstance } from '../utils/randomSeed'
import { gsap } from 'gsap';
import { lerp } from '../utils/maths';

export default class extends module {
    constructor(m) {
        super(m);

        this.elephant = this.$('himself')[0];
        this.cursor = this.$('cursor')[0];

        this.events = {
            click: 'click',
            mousedown: 'mousedown',
            mouseup: 'mouseup',
            mousemove: 'mousemove',
            mouseenter: {
                inner: 'mouseenter'
            },
            mouseleave: {
                inner: 'mouseleave'
            }
        }
    }

    init() {
        this.randomSeed = new randomSeedInstance();

        this.hasMouseDown = true;
        this.zOffset = 0;
        this.firstHit = true;

        gsap.delayedCall(1,() => {
            this.ready();
        });
    }

    ready() {
        this.isReady = true;
            
        this.x = this.getBCR().width/2;
        this.y = this.getBCR().height/2;

        this.goalX = this.getBCR().width/2;
        this.goalY = this.getBCR().height/2;

        this.cursorX = this.getBCR().width/2;
        this.cursorY = this.getBCR().height/2;
        this.cursorLerpedX = this.getBCR().width/2;
        this.cursorLerpedY = this.getBCR().height/2;
        
        this.speed = 0;
        this.goalSpeed = 0;
        this.speedOffset = 30;

        this.elephant.style.transform = `translate3d(${this.x}px, ${this.y}px, 0)`;

        gsap.delayedCall(2,() => {
            this.resize();
        })

        this.resize();

        this.bindResize = this.resize.bind(this);
        window.addEventListener('resize', this.bindResize);

        this.hasGoal = false;
        this.lerp = {
            value: 0.8
        }
    }

    trigger(e) {
        if(e.mode == 'enter') {            
            if(this.firstHit) {
                this.firstHit = false;
                this.el.classList.add('is-visible');
            }
            this.ready();
            this.draw();
            
        } else {
            cancelAnimationFrame(this.raf);
        }
    }

    click(e) {
        if(!window.isMobile) return;

        let x = e.pageX;
        let y = e.pageY - this.getBCR().top;
        
        this.hasGoal = true;

        if(this.callback != undefined) {
            this.callback.kill();
        }

        if(this.deceleration != undefined) {
            this.deceleration.kill();
        }

        gsap.to(this.lerp,{
            value: 0.03,
            duration: 0,
            delay: 0,
            onComplete:() => {

                this.callback = gsap.delayedCall(2.2, () => {
                    this.hasGoal = false;

                    this.deceleration = gsap.to(this.lerp,{
                        value: 0.8,
                        duration: 2,
                        onComplete: () => {
                        }
                    });
                    
                });
            }
        });

        this.goalX = x;
        this.goalY = y;

    }   

    mousedown(e) {
        if(window.isMobile) return;
        
        this.hasMouseDown = true;
        
        let x = e.pageX;
        let y = e.pageY - this.getBCR().top;

        if(this.callback != undefined) {
            this.callback.kill();
        }

        if(this.deceleration != undefined) {
            this.deceleration.kill();
        }
        this.hasGoal = true;

        gsap.to(this.lerp,{
            value: 0.02,
            duration: 0,
            delay: 0
        });

        this.goalX = x;
        this.goalY = y;
    }

    mousemove(e) {
        if(window.isMobile) return;

        this.cursorX = e.pageX;
        this.cursorY = e.pageY - this.getBCR().top;

        if(!this.hasGoal) return;

        if(this.hasMouseDown) {
            let x = e.pageX;
            let y = e.pageY - this.getBCR().top;

            this.goalX = x;
            this.goalY = y;
        }
    }

    mouseup(e) {
        if(window.isMobile) return;
        
        let x = e.pageX;
        let y = e.pageY - this.getBCR().top;

        this.goalX = x;
        this.goalY = y;

        this.hasMouseDown = false;

        this.callback = gsap.delayedCall(3, () => {
            this.hasGoal = false;

            this.deceleration = gsap.to(this.lerp,{
                value: 0.8,
                duration: 3
            });
        });
    }

    mouseenter() {
        if(window.isMobile) return;

        this.el.classList.add('is-hover');
    }

    mouseleave() {
        if(window.isMobile) return;

        this.el.classList.remove('is-hover');
    }

    draw() {
        if(!this.isReady) return;

        let noise = this.randomSeed.noise3D(0.1, 0.1, this.zOffset, 5, 1);
        let angle = noise * Math.PI * 2;

        if(!this.hasGoal) {
            this.goalX = this.x + (Math.sin(angle));
            this.goalY = this.y + (Math.cos(angle));
        }
        this.x = lerp(this.x, this.goalX, this.lerp.value);
        this.y = lerp(this.y, this.goalY, this.lerp.value);

        if(this.x > this.limitX) {
            this.x = -this.elephantWidth/2;
        }
        if(this.x < -this.elephantWidth/2) {
            this.x = this.limitX;
        }

        if(this.y > this.limitY) {
            this.y = -this.elephantHeight/2;
        }
        if(this.y < -this.elephantHeight/2) {
            this.y = this.limitY;
        }

        this.goalSpeed = this.speedOffset * ((this.goalX - this.x) / this.width);
        this.speed = lerp(this.speed, this.goalSpeed, 0.1);

        this.elephant.style.transform = `translate3d(${this.x - this.elephantWidth/2}px, ${this.y - this.elephantHeight/3}px, 0) rotate(${this.speed}deg)`;
        this.zOffset += 0.0001;

        this.cursorLerpedX = lerp(this.cursorLerpedX, this.cursorX, 0.1);
        this.cursorLerpedY = lerp(this.cursorLerpedY, this.cursorY, 0.1);

        this.cursor.style.transform = `translate3d(${this.cursorLerpedX}px, ${this.cursorLerpedY}px, 0)`;


        this.raf = requestAnimationFrame(() => this.draw());
    }

    getBCR() {
        return this.el.getBoundingClientRect();
    }

    resize() {
        this.elephantWidth = this.elephant.getBoundingClientRect().width;
        this.elephantHeight= this.elephant.getBoundingClientRect().height;
        this.width = this.getBCR().width;
        this.height = this.getBCR().height;

        this.limitX = this.width + (this.elephantWidth/2);
        this.limitY = this.height + (this.elephantHeight/2);
    }

    destroy() {
        cancelAnimationFrame(this.raf);
        window.removeEventListener('resize', this.bindResize);
    }
    
}
